import styles from './LoaderText.module.scss';
import cn from 'classnames';

interface ILoaderTextProps {
  text?: string;
  size?: number;
  className?: string;
  children?: React.ReactNode;
  isLoading: boolean;
}

const LoaderText = ({
  text = 'ObjectTest',
  size = 38,
  children,
  className,
  isLoading,
}: ILoaderTextProps) => {
  return (
    <div
      style={isLoading ? { opacity: 0 } : { opacity: 1 }}
      className={cn(styles.loaderText, className)}
    >
      {isLoading ? (
        <span style={{ fontSize: size }} className={styles.loaderTextSpan}>
          {text}
        </span>
      ) : (
        children
      )}
    </div>
  );
};

export default LoaderText;
